
const PASSWORD_REG = /^[a-zA-Z0-9]{6,}$/;
export function validPassword(pwd) {
    return PASSWORD_REG.test(pwd)
}

const BIRTH_REG =  /^((0?[1-9])|([1-2][0-9])|30|31)((0?[1-9])|(1[0-2]))$/;
export function validBirth(pwd) {
    return BIRTH_REG.test(pwd)
}